module.exports = __webpack_public_path__ + "media/images/lp/1/plight1-pc-0c659335ccc457a782c643da302fc257.png";